export function extractGedcomPerson(gedcomPerson) {
  if (!gedcomPerson) return {}
  if (!Object.keys(gedcomPerson).length) return {}
  if (gedcomPerson.name) return gedcomPerson

  const person = gedcomPerson.persons[0]
  const personData = {
    name: '',
    gender: 'Unknown',
    lifespan: '',
    id: '111-1111',
  }

  personData.gender = person.display.gender || 'Unknown'
  personData.id = person.id
  personData.lifespan = person.display.lifespan

  const nameObj = person.names?.[0].nameForms?.[0]

  personData.name = nameObj?.fullText ? nameObj.fullText : ''

  personData.gedcomPerson = gedcomPerson

  return personData
}

export function parseTreeRelationships(family) {
  const parsedFamily = {
    parents: [],
    spouses: [],
    children: [],
  }

  if (family?.spouses) {
    family.spouses.forEach((relationship) => {
      const parsedTreeCouple = parseTreeCouples(relationship)
      if (
        parsedTreeCouple &&
        parsedTreeCouple.children &&
        (parsedTreeCouple.spouse1.id !== 'UNKNOWN' || parsedTreeCouple.spouse2.id !== 'UNKNOWN')
      ) {
        parsedFamily.spouses.push(parsedTreeCouple)
      }
    })
  }

  if (family?.parents) {
    family.parents.forEach((relationship) => {
      const parsedTreeCouple = parseTreeCouples(relationship)
      if (parsedTreeCouple) {
        parsedFamily.parents.push(parsedTreeCouple)
      }
    })
  }

  return parsedFamily
}

export function parseTreeCouples(relationship) {
  if (relationship.coupleId === null || relationship.coupleId === undefined) return null
  const spouse1 = {
    gender: relationship?.parent1?.gender,
    id: relationship?.parent1?.id,
    name: relationship?.parent1?.name,
    lifespan: relationship?.parent1?.lifeSpan,
  }
  const spouse2 = {
    gender: relationship?.parent2?.gender,
    id: relationship?.parent2?.id,
    name: relationship?.parent2?.name,
    lifespan: relationship?.parent2?.lifeSpan,
  }
  const relationshipDate = relationship.event?.details?.date
  const relationshipPlace = relationship.event?.details?.place
  const coupleEvent = {
    ...relationship.event,
    originalDate: relationshipDate?.originalText || relationshipDate?.normalizedText,
    originalPlace: relationshipPlace?.originalText || relationshipPlace?.normalizedText,
    type: relationship.event?.type,
  }
  return { spouse1, spouse2, children: relationship.children, coupleEvent }
}

export function getLinkPage() {
  if (window.location.pathname.includes('files')) return 'Files'
  if (window.location.pathname.includes('summary')) return 'Summary'
  if (window.location.pathname.includes('compare')) return 'Compare'
  return ''
}

export function getAnalyticsObject(linkName) {
  const linkApp = 'Tree: Import'
  const linkPage = getLinkPage()

  return {
    link_app: linkApp,
    link_page: linkPage,
    link_name: linkName,
  }
}
